<style lang="less" rel="stylesheet/less" scoped>
    @h:60px;
    .question-input{
        min-height:@h;
        background:rgba(255,255,255,1);
        border-radius:5px;
        box-shadow:0px 2px 10px 2px rgba(51,51,51,0.1);
        margin-bottom:15px;
        display:flex;
        .label{
            line-height:@h;
            padding-left:20px;
            font-weight:bold;
            font-size:16px;
            color:rgba(51,51,51,1);
            white-space: nowrap;
        }
        .input{
            flex-grow:1;
            line-height:@h;
            margin:0 10px;
            input{
                border-bottom:1px solid #333;
                width:100%;
                text-align:center;
                font-size:16px;
                font-weight:bold;
                color:#333;
                min-width:100px;
                &::placeholder{
                    color:#aaa;
                }
            }
        }
        .suffix{
            line-height:@h;
            font-size:16px;
            font-weight:bold;
            color:rgba(153,153,153,1);
            padding-right:20px;
        }
    }
</style>
<template>
    <div class="question-input">
        <div class="label">
            {{item.title}}:
        </div>
        <div class="input">
            <input v-if="isTypeString(item)" :placeholder="item.placeholder" v-model="item.answer" type="text"/>
            <input v-if="isTypeNumber(item)" :placeholder="item.placeholder" v-model="item.answer" type="number"/>
        </div>
        <div class="suffix">
            {{item.suffix}}
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import {INPUT_TYPE} from '../lib/const';
    import event from '../lib/event';

    export default {
        props:['item'],
        data() {
            return {}
        },
        computed: {},
        methods: {
            isTypeString(item){
                return item.input_type === INPUT_TYPE.STRING;
            },
            isTypeNumber(item){
                return item.input_type === INPUT_TYPE.NUMBER;
            },
            isRequired(){
                return this.item.required !== false;
            },
            checkValid(){
                if(this.isRequired() && !this.item.answer.trim()){
                    event.emit('toast',this.item.warn_text||'此项必填');
                    return false;
                }
                return true;
            }
        },
        components: {},
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// QuestionTypeInput.vue?71a4610e